var dsox = dsox || {};
dsox.HiddenUTMField = (function () {
    

    var setHiddenUTMFields = function ($) {
        var query = location.href.split("?").pop().split("&");
        var split;

        if (query.length) {
            for (var i = 0; i < query.length; i++ ) {
                split = query[i].split("=");

                $('input').each(function () {
                    var $this = $(this);
                    
                    if($this.attr('name')){
                        var inputName = $this.attr('name').split(".");
                
                        if (inputName[1] && inputName[1].toLowerCase() === split[0]) {
                            $this.val(split[1].replace(/"/g, '\\"'));
                        }
                    }
                });
            }
        }
    }

    return {
        setHiddenUTMFields: setHiddenUTMFields
    }

}());